
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/content/p/freecourses/[goalUID]",
      function () {
        return require("private-next-pages/content/p/freecourses/[goalUID].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/content/p/freecourses/[goalUID]"])
      });
    }
  